export const localForagePagination = {
    state: {},
    mutations: {},
    actions: {
        // eslint-disable-next-line no-empty-pattern
        async saveLocalForagePagination({}, payload) {
            const pagination = await this.$storage.getItem('perPage')
            if (!pagination) {
                await this.$storage.setItem('perPage', {})
            }

            const tmpPerPage = await this.$storage.getItem('perPage')
            if (payload) {
                Object.assign(tmpPerPage, payload)
            }

            await this.$storage.setItem('perPage', tmpPerPage)
        },

        async setDefaultPerPage({ dispatch }) {
            const pagination = await this.$storage.getItem('perPage')

            if (pagination) {
                Object.keys(pagination).forEach(key => {
                    const moduleName =
                        key.charAt(0).toUpperCase() + key.slice(1)
                    dispatch(`set${moduleName}PerPage`, pagination[key])
                })
            }
        }
    },
    getters: {}
}
